<!-- Operational Report -->
<div class="operational-report-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-main">
        <div class="header-icon">
          <i class="fas fa-chart-line"></i>
        </div>
        <div class="header-text">
          <h1 class="page-title">Operational Report</h1>
          <p class="page-description">Monitor waitstaff performance, kitchen efficiency, and order delays</p>
        </div>
      </div>
      <div class="header-actions">
        <button class="btn btn-outline-secondary" (click)="onTabChange(active)">
          <i class="fas fa-sync-alt me-1"></i>
          Refresh
        </button>
      </div>
    </div>
  </div>

  <!-- Tab Navigation -->
  <div class="data-panel">
    <div class="panel-header" style="padding: 0; border-bottom: none;">
      <ul ngbNav [(activeId)]="active" class="nav-tabs" style="border-bottom: none; padding: 8px 20px 0;">
        <li [ngbNavItem]="'waitstaff'">
          <a ngbNavLink (click)="onTabChange('waitstaff')">
            <i class="fas fa-user-tie me-2"></i>Waitstaff Performance
          </a>
        </li>
        <!-- <li [ngbNavItem]="'kitchen'">
          <a ngbNavLink (click)="onTabChange('kitchen')">
            <i class="fas fa-utensils me-2"></i>Kitchen Performance
          </a>
        </li> -->
        <li [ngbNavItem]="'delays'">
          <a ngbNavLink (click)="onTabChange('delays')">
            <i class="fas fa-clock me-2"></i>Order Delays
          </a>
        </li>
      </ul>
    </div>

    <!-- KPI Summary Cards -->
    <div *ngIf="active === 'waitstaff'" style="padding: 20px 20px 0;">
      <div class="row g-3 mb-3">
        <div class="col-md-6">
          <div class="kpi-card">
            <div class="kpi-icon" style="background: var(--info-bg); color: var(--info-text);">
              <i class="fas fa-receipt"></i>
            </div>
            <div class="kpi-content">
              <span class="kpi-label">Total Orders</span>
              <span class="kpi-value">{{summaryMetrics.waitstaff.total_orders}}</span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="kpi-card">
            <div class="kpi-icon" style="background: var(--warning-bg); color: var(--warning-text);">
              <i class="fas fa-stopwatch"></i>
            </div>
            <div class="kpi-content">
              <span class="kpi-label">Avg Processing Time</span>
              <span class="kpi-value">{{summaryMetrics.waitstaff.average_processing_time}}</span>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-4">
          <div class="kpi-card">
            <div class="kpi-icon" style="background: var(--success-bg); color: var(--success-text);">
              <i class="fas fa-check-circle"></i>
            </div>
            <div class="kpi-content">
              <span class="kpi-label">On-Time Orders</span>
              <span class="kpi-value">{{summaryMetrics.waitstaff.on_time_orders}}</span>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <div *ngIf="active === 'delays'" style="padding: 20px 20px 0;">
      <div class="row g-3 mb-3">
        <div class="col-md-4">
          <div class="kpi-card">
            <div class="kpi-icon" style="background: var(--info-bg); color: var(--info-text);">
              <i class="fas fa-receipt"></i>
            </div>
            <div class="kpi-content">
              <span class="kpi-label">Total Orders</span>
              <span class="kpi-value">{{summaryMetrics.delays.total_orders | number}}</span>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="kpi-card">
            <div class="kpi-icon" style="background: var(--danger-bg); color: var(--danger-text);">
              <i class="fas fa-exclamation-triangle"></i>
            </div>
            <div class="kpi-content">
              <span class="kpi-label">Delayed Orders</span>
              <span class="kpi-value">{{summaryMetrics.delays.delayed_orders | number}}</span>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="kpi-card">
            <div class="kpi-icon" style="background: var(--warning-bg); color: var(--warning-text);">
              <i class="fas fa-hourglass-half"></i>
            </div>
            <div class="kpi-content">
              <span class="kpi-label">Avg Delay Time</span>
              <span class="kpi-value">{{summaryMetrics.delays.average_delay_time}} Minutes</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Search Bar -->
    <div style="padding: 0 20px 16px;">
      <div class="search-box">
        <div class="search-input-wrapper">
          <i class="fas fa-search search-icon"></i>
          <input type="text" class="search-input" placeholder="Search..." [(ngModel)]="searchTerm" (input)="onSearch()">
        </div>
      </div>
    </div>

    <!-- Waitstaff Performance Table -->
    <div *ngIf="active === 'waitstaff'">
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th class="ps-4">Waiter</th>
              <th>Total Orders Handled</th>
              <th>Total Sales Amount</th>
              <th>Average Order Value</th>
              <th>Average Customer Rating</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td class="ps-4">
                <div class="d-flex align-items-center gap-3">
                  <div class="avatar-circle"
                    [style.backgroundImage]="item.waiter_image ? 'url(' + item.waiter_image + ')' : ''"
                    [style.backgroundColor]="!item.waiter_image ? 'var(--bg-muted)' : ''">
                    @if (!item.waiter_image) {
                    <span class="avatar-initial">{{item.waiter_name.charAt(0)}}</span>
                    }
                  </div>
                  <span class="fw-medium">{{item.waiter_name}}</span>
                </div>
              </td>
              <td>
                <span class="badge badge-soft-info">{{item.total_orders_handled}}</span>
              </td>
              <td class="fw-semibold" style="color: var(--success-text);">
                &#8358;{{item.total_sales_amount | number}}
              </td>
              <td>&#8358;{{item.average_order_value || 0 | number:'1.0-0'}}</td>
              <td>
                @if (item.average_customer_rating) {
                <div class="d-flex align-items-center gap-1">
                  <i class="fa fa-solid fa-star" style="color: var(--warning-text); font-size: 12px;"></i>
                  <span class="fw-medium">{{item.average_customer_rating}}</span>
                </div>
                } @else {
                <span style="color: var(--text-tertiary); font-size: 12px;">No ratings</span>
                }
              </td>
            </tr>
            <tr *ngIf="filteredData.length === 0">
              <td colspan="5">
                <div class="empty-state">
                  <div class="empty-icon">
                    <i class="fas fa-user-tie fa-3x"></i>
                  </div>
                  <h5 class="empty-title">No data to display</h5>
                  <p class="empty-subtitle">There is no waitstaff performance data available.</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      @if (total > pageSize) {
      <div class="panel-footer">
        <span class="info-text">Showing page {{page}} of {{(total / pageSize) | number:'1.0-0'}}</span>
        <ngb-pagination [collectionSize]="total" [(page)]="page"
          [pageSize]="pageSize" [maxSize]="5" [rotate]="true" [ellipses]="false" [boundaryLinks]="true"
          (pageChange)="refresh($event)">
        </ngb-pagination>
      </div>
      }
    </div>

    <!-- Kitchen Performance Table -->
    <div *ngIf="active === 'kitchen'">
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th class="ps-4">Order ID</th>
              <th>Order Items</th>
              <th>Preparation Time</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td class="ps-4">
                <span class="badge badge-light">{{item.order_id}}</span>
              </td>
              <td>{{item.order_items}}</td>
              <td>
                <span class="badge badge-soft-warning">{{item.preparation_time}}</span>
              </td>
            </tr>
            <tr *ngIf="filteredData.length === 0">
              <td colspan="3">
                <div class="empty-state">
                  <div class="empty-icon">
                    <i class="fas fa-utensils fa-3x"></i>
                  </div>
                  <h5 class="empty-title">No data to display</h5>
                  <p class="empty-subtitle">There is no kitchen performance data available.</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Order Delays Table -->
    <div *ngIf="active === 'delays'">
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th class="ps-4">Order ID</th>
              <th>Order Items</th>
              <th>Delay Time</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td class="ps-4">
                <span class="badge badge-light">{{item.order_id}}</span>
              </td>
              <td>{{item.order_items}}</td>
              <td>
                <span class="badge badge-soft-danger">{{item.delay_time}}</span>
              </td>
              <td style="color: var(--text-secondary);">{{item.reason}}</td>
            </tr>
            <tr *ngIf="filteredData.length === 0">
              <td colspan="4">
                <div class="empty-state">
                  <div class="empty-icon">
                    <i class="fas fa-clock fa-3x"></i>
                  </div>
                  <h5 class="empty-title">No data to display</h5>
                  <p class="empty-subtitle">There is no order delay data available.</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
